import styled from 'styled-components';

const StyledGrid = styled.div`
    display: grid;
    align-items: ${({ alignItems }) => alignItems};
    background-color: ${({ backgroundColour }) => backgroundColour};
    border: ${({ border }) => border};
    border-radius: ${({ borderRadius }) =>
        Array.isArray(borderRadius)
            ? `${borderRadius[0]}px ${borderRadius[1]}px ${borderRadius[2]}px ${borderRadius[3]}px`
            : `${borderRadius}px`};
    gap: ${({ gap }) => (gap ? `${gap}px` : 0)};
    grid-template-columns: ${({ numberOfColumns }) => `repeat(${numberOfColumns}, minmax(0, 1fr))`};
    height: ${({ height }) => height};
    justify-items: ${({ justifyItems }) => justifyItems};
    overflow-x: ${({ overflowX }) => overflowX};
    overflow-y: ${({ overflowY }) => overflowY};
    padding-top: ${({ paddingY }) => `${paddingY}px`};
    padding-bottom: ${({ paddingY }) => `${paddingY}px`};
    padding-left: ${({ paddingX }) => `${paddingX}px`};
    padding-right: ${({ paddingX }) => `${paddingX}px`};
    width: ${({ width }) => width};
`;

export const Grid = ({
    children,
    alignItems = 'stretch',
    border = 'none',
    backgroundColour = 'transparent',
    borderRadius = 0,
    gap = null,
    height = 'auto',
    justifyItems = 'stretch',
    numberOfColumns,
    overflowX = 'visible',
    overflowY = 'visible',
    paddingX = 0,
    paddingY = 0,
    width = 'auto',
}) => {
    return (
        <StyledGrid
            alignItems={alignItems}
            backgroundColour={backgroundColour}
            border={border}
            borderRadius={borderRadius}
            gap={gap}
            height={height}
            justifyItems={justifyItems}
            numberOfColumns={numberOfColumns}
            overflowX={overflowX}
            overflowY={overflowY}
            paddingX={paddingX}
            paddingY={paddingY}
            width={width}
        >
            {children}
        </StyledGrid>
    );
};

// enums for align-self ( vertical )- start, center, end, stretch (default, items shrinks if value is start, center, end)
// enums for justify-self ( horizontal ) - start, center, end, stretch (default, items shrinks if value is start, center, end)
const StyledGridItem = styled.div`
    align-self: ${({ alignSelf }) => alignSelf};
    justify-self: ${justifySelf => justifySelf};
`;

export const GridItem = ({ children, alignSelf = 'stretch', justifySelf = 'stretch' }) => {
    return (
        <StyledGridItem alignSelf={alignSelf} justifySelf={justifySelf}>
            {children}
        </StyledGridItem>
    );
};

export const CenteredGridItem = ({ children }) => {
    return (
        <GridItem alignSelf="center" justifySelf="center">
            {children}
        </GridItem>
    );
};
